module.exports = __webpack_public_path__ + "static/media/how_are_you.5cb4a245.png";